import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { PREVENTIVE_TASK_PROJECTION_AREA_ENDPOINT } from '../../../../config/endpoints';
import { GET } from '../../../../config/permissions';

export const PreventiveTaskProjectionAreaViewField = ({ onChange }) => (
  <Label className="mr-3">
    <Field
      name="view"
      component="input"
      type="radio"
      value="AREA"
      onChange={onChange}
    />{' '}
    Mi área
  </Label>
);

PreventiveTaskProjectionAreaViewField.propTypes = {
  onChange: PropTypes.func,
};

PreventiveTaskProjectionAreaViewField.defaultProps = {
  onChange: null,
};

const connectedComponent = connect(
  null,
  null,
)(PreventiveTaskProjectionAreaViewField);

export default withEndpointAuthorization({
  url: PREVENTIVE_TASK_PROJECTION_AREA_ENDPOINT,
  permissionType: GET,
})(connectedComponent);
